import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'pcs-layout',
  templateUrl: './layout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LayoutComponent {
  @Input() fullScreen = false;

  get containerClasses() {
    return this.fullScreen ? 'container-fluid full-screen' : 'container';
  }

}
